var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Embedded"},[_c('navbar',{attrs:{"showShadow":false,"scrollChange":false,"tabId":7}}),_c(_vm.current,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }